import api from '@/api';
import {
  CouponWorkorderCreate,
  TaxCoupon,
  TaxCouponCreateRequest,
  TaxCouponDetailRequest,
  TaxCouponGenerateTx2Request,
  TaxCouponItem,
  TaxCouponItemCreateRequest,
  TaxCouponItemEditRequest,
  TaxCouponItemRemoveRequest,
  TaxCouponListRequest,
  TaxCouponListResponse,
  TaxCouponPayment,
  TaxCouponPaymentCreateRequest,
  TaxCouponPaymentEditRequest,
  TaxCouponPaymentRemoveRequest,
  TaxCouponRecipientCreateRequest,
  TaxCouponRecipientCreateResponse,
  TaxCouponUpdadeCodeRequest,
} from './coupons.types';

const CONTROLLER_URL = `/coupon`;

export default {
  async detail(params: TaxCouponDetailRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/coupons/${params.taxCouponId}`,
      null,
    )) as unknown;
    return result as TaxCoupon;
  },

  async list(params: TaxCouponListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/coupons`,
      params,
    )) as unknown;
    return result as TaxCouponListResponse;
  },

  async create(data: TaxCouponCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons`,
      data,
      null,
    )) as unknown;
    return result as TaxCoupon;
  },

  async cancel(id: string) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons/${id}/cancel`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async remove(id: string) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/coupons/${id}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async paymentCreate({
    taxCouponId,
    payments,
  }: TaxCouponPaymentCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/payments`,
      payments,
      null,
    )) as unknown;
    return result as TaxCouponPayment;
  },

  async paymentEdit({ taxCouponId, ...data }: TaxCouponPaymentEditRequest) {
    const result = (await api.put(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/payments/${data.id}`,
      data,
      null,
    )) as unknown;
    return result as TaxCouponPayment;
  },

  async paymentRemove({
    taxCouponId,
    taxCouponPaymentId,
  }: TaxCouponPaymentRemoveRequest) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/payments/${taxCouponPaymentId}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async itemList(taxCouponId?: string) {
    const result = (await api.get(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/items`,
      {},
    )) as unknown;
    return result as TaxCouponItem[];
  },

  async itemCreate({ taxCouponId, ...data }: TaxCouponItemCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/items`,
      data.couponItems,
    )) as unknown;
    return result as TaxCouponItem[];
  },

  async itemEdit({ taxCouponId, ...data }: TaxCouponItemEditRequest) {
    const result = (await api.put(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/items/${data.id}`,
      data,
      null,
    )) as unknown;
    return result as TaxCouponItem;
  },

  async itemRemove({
    taxCouponId,
    taxCouponItemId,
  }: TaxCouponItemRemoveRequest) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/items/${taxCouponItemId}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async recipientCreate({
    taxCouponId,
    ...data
  }: TaxCouponRecipientCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons/${taxCouponId}/recipients`,
      data,
    )) as unknown;
    return result as TaxCouponRecipientCreateResponse;
  },

  async generateTx2(data: TaxCouponGenerateTx2Request) {
    const result = (await api.post(
      `${CONTROLLER_URL}/coupons/generate/tx2`,
      data,
    )) as unknown;
    return result as string;
  },

  async updateCode({ couponId, ...data }: TaxCouponUpdadeCodeRequest) {
    const result = (await api.patch(
      `${CONTROLLER_URL}/coupons/${couponId}`,
      data,
      null,
    )) as unknown;
    return result as string;
  },

  async workorderCreate(data: CouponWorkorderCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/work-orders/cfe`,
      data,
      null,
    )) as unknown;
    return result as TaxCoupon;
  },
};
